<!-- @format -->

<ul class="no-list-style-type">
  @for (extension of studyRightExtensions; track extension) {
    <li class="sis-mb-sm">
      {{ extension.extensionCount }}
      {{ "PROFILE.EXTENSIONS." + (extension.extensionCount === 1 ? "SEMESTER" : "SEMESTERS") | translate }},
      {{ extension | studyRightExtensionValidity | localDateRange }}
      @if (showShowDetails) {
        <sis-button [link]="true" (clicked)="showDetails.emit(extension)" class="d-block details-button">
          {{ "PROFILE.EXTENSIONS.SHOW_DETAILS" | translate }}
        </sis-button>
      }
    </li>
  }
</ul>
